import { useCallback, useMemo } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useApi = () => {
  const { getToken } = useAuth();
  const authed = useCallback(async () => ({ Authorization: `Bearer ${await getToken()}` }), [getToken]);
  return useMemo(() => ({
    get: async (p) => (await axios.get(`${API}${p}`, { headers: await authed() })).data,
    post: async (p, b) => (await axios.post(`${API}${p}`, b, { headers: await authed() })).data,
    patch: async (p, b) => (await axios.patch(`${API}${p}`, b, { headers: await authed() })).data,
    delete: async (p, b) => (await axios.delete(`${API}${p}`, { headers: await authed(), ...(b ? { data: b } : {}) })).data,
    put: async (p, b) => (await axios.put(`${API}${p}`, b, { headers: await authed() })).data,
    headers: authed,
  }), [authed]);
};

export const money = (n, compact = false) =>
  n == null ? "—" : new Intl.NumberFormat("en-US", {
    style: "currency", currency: "USD", maximumFractionDigits: 0,
    ...(compact ? { notation: "compact", maximumFractionDigits: 1 } : {}),
  }).format(n);

export const fmtDate = (iso) =>
  iso ? new Date(String(iso).slice(0, 10) + "T00:00:00").toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : null;

export const errText = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d && typeof d.message === "string") return d.message;
  return fallback;
};
